<template>
  <button
    aria-label="Toggle Accessibility Options"
    id="accessibility-toggle"
    title="Toggle Accessibility Options"
    @click="toggleAccessibility"
  >
    <i class="custom-eye open" ref="eye"></i>
  </button>
</template>

<script>
import jQuery from 'jquery'

export default {
  methods: {
    toggleAccessibility() {
      jQuery('.accessibility-toolbar').toggleClass('button-skip-content')
      jQuery(this.$refs.eye).toggleClass('open')
    },
  },
}
</script>
